export default "__VITE_ASSET__qft3ZJ5Y__"